import { render } from "./MiniPlayerCard.vue?vue&type=template&id=2347aff4"
import script from "./MiniPlayerCard.vue?vue&type=script&lang=js"
export * from "./MiniPlayerCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__